import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getAuthTokens } from '../utils/auth';
import api from './middleware';

export const workflowApi = {
  // Get workflows for a test suite
  getWorkflowsBySuite: async (suiteId) => {
    try {
      const response = await api.get(`/api/testsuite/${suiteId}/workflows`);
      return response.data;
    } catch (error) {
      console.error('Get workflows error:', error);
      throw error;
    }
  },

  // Create a new workflow
  createWorkflow: async (suiteId, workflowData) => {
    try {
      const response = await api.post(
        `/api/workflow/create`,
        {
          ...workflowData,
          test_suite_id: suiteId
        }
      );

      return response.data;
    } catch (error) {
      console.error('Create workflow error:', error);
      throw error;
    }
  },

  // Delete a workflow
  deleteWorkflow: async (workflowId) => {
    try {
      const response = await api.delete(`/api/workflows/${workflowId}`);
      return response.data;
    } catch (error) {
      console.error('Delete workflow error:', error);
      throw error;
    }
  },

  // Update a workflow
  updateWorkflow: async (workflowId, workflowData) => {
    try {
      const response = await api.put(
        `/api/workflows/${workflowId}`,
        workflowData
      );

      return response.data;
    } catch (error) {
      console.error('Update workflow error:', error);
      throw error;
    }
  },

  // Get a workflow by ID
  getWorkflowById: async (workflowId) => {
    try {
      const response = await api.get(`/api/workflows/${workflowId}`);
      return response.data;
    } catch (error) {
      console.error('Get workflow error:', error);
      throw error;
    }
  }
};

export default workflowApi;
